// extracted by mini-css-extract-plugin
export default {"lightSpin":"Loader_lightSpin__A+FiG","darkSpin":"Loader_darkSpin__wqkCn"};